import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type { TypeGetOutboundsListParams, TypeGetOutboundsListResponse } from '~/types/delivery-agency.types';

/**
 * [합포 단위 관리] 출고 단위 리스트 조회 API
 */
export const fetchOutboundsList = async (params: TypeGetOutboundsListParams): Promise<TypeGetOutboundsListResponse> => {
  const { data } = await axiosInstance.get<TypeGetOutboundsListResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_OUTBOUNDS_LIST,
    { params }
  );
  return data;
};

type UseGetOutboundsListQueryOptions = {
  params: TypeGetOutboundsListParams;
  enabled?: boolean;
  showGlobalErrorToast?: boolean;
};

/**
 * [합포 단위 관리] 출고 단위 리스트 조회 Query Hook
 */
export const useGetOutboundsListQuery = ({
  params,
  enabled = true,
  showGlobalErrorToast = true,
}: UseGetOutboundsListQueryOptions) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.outboundsList(params),
    queryFn: () => fetchOutboundsList(params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
    placeholderData: keepPreviousData,
    meta: { showGlobalErrorToast },
  });
};
